(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sorted-bubble-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sorted-bubble-comparison')) {
  customElements.define('sorted-bubble-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.handlers) return;
      this.timers = [];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handlers = [];
      const bind = (el, fn) => {
        el.addEventListener('click', fn);
        this.handlers.push([el, fn]);
      };
      bind(this.querySelector('[data-pressure-play]'), () => this.playDemo());
      if (!this.reduced && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.playDemo(false);
            this.observer.disconnect();
          }
        }, { threshold: .15 });
        this.observer.observe(this);
      }
    }
    clearTimers() {
      this.timers?.forEach(clearTimeout);
      this.timers = [];
    }
    playDemo(announce = true) {
      this.clearTimers();
      this.dataset.phase = 'ready';
      const status = this.querySelector('[data-demo-status]');
      status.textContent = '';
      if (this.reduced) {
        this.dataset.phase = 'after';
        if (announce) status.textContent = this.querySelector('.sbc-pressure-controls p').textContent;
        return;
      }
      this.timers.push(setTimeout(() => { this.dataset.phase = 'compress'; }, 350));
      this.timers.push(setTimeout(() => {
        this.dataset.phase = 'after';
        if (announce) status.textContent = this.querySelector('.sbc-pressure-controls p').textContent;
      }, 1650));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.clearTimers();
      this.handlers?.forEach(([el, fn]) => el.removeEventListener('click', fn));
      this.handlers = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorted-packing-kit"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sorted-packing-card'))customElements.define('sorted-packing-card',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const form=this.querySelector('form'),button=form.querySelector('button'),status=this.querySelector('[role="status"]');
    if(!form.querySelector('[name="id"]').value){button.disabled=true;return;}
    form.addEventListener('change',()=>{status.textContent='';});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(button.disabled)return;
      const label=button.textContent;button.disabled=true;button.textContent=this.dataset.adding;status.textContent='';
      const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      const body=new FormData(form);const root=window.Shopify?.routes?.root||'/';
      body.set('sections',cart?cart.getSectionsToRender().map(s=>s.id).join(','):'cart-icon-bubble');body.set('sections_url',window.location.pathname);
      cart?.setActiveElement(button);
      try{
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body});const data=await response.json();
        if(!response.ok||data.status)throw new Error(data.description||this.dataset.error);
        status.textContent=this.dataset.added;
        if(cart&&data.sections){cart.classList.remove('is-empty');cart.renderContents(data);}
        else if(data.sections?.['cart-icon-bubble']){const html=new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');const target=document.getElementById('cart-icon-bubble');if(target)target.innerHTML=html.querySelector('.shopify-section')?.innerHTML||html.body.innerHTML;}
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'packing-kit',productVariantId:body.get('id'),cartData:data});
      }catch(error){status.textContent=error.message||this.dataset.error;}
      finally{button.disabled=false;button.textContent=label;}
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorted-roll-upgrade"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sorted-roll-upgrade'))customElements.define('sorted-roll-upgrade',class extends HTMLElement{
  connectedCallback(){
    this.querySelector('button').onclick=()=>{
      const picker=this.closest('product-info')?.querySelector('variant-selects');if(!picker)return;
      const radio=Array.from(picker.querySelectorAll('input[type="radio"]')).find(el=>el.value==='10 m');
      if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));return;}
      const option=Array.from(picker.querySelectorAll('option')).find(el=>el.value==='10 m');
      if(option){option.parentElement.value=option.value;option.parentElement.dispatchEvent(new Event('change',{bubbles:true}));}
    };
    if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(data.sectionId===this.dataset.section)this.hidden=String(data.variant?.id)!==this.dataset.small;});
  }
  disconnectedCallback(){this.unsubscribe?.();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorted-support"] && !Shopify.designMode) return;
  try {
    function enhanceSortedSupport(root = document) {
  root.querySelectorAll('[data-sorted-policy]:not([data-enhanced])').forEach(container => {
    container.dataset.enhanced = 'true';
    let section;
    Array.from(container.childNodes).forEach(node => {
      if (node.nodeName === 'H2') {
        section = document.createElement('section');
        section.className = 'ss-policy-section';
        container.insertBefore(section, node);
      }
      if (section) section.append(node);
    });
  });
  root.querySelectorAll('[data-sorted-faq]:not([data-enhanced])').forEach(container => {
    container.dataset.enhanced = 'true';
    Array.from(container.querySelectorAll(':scope > h3')).forEach(heading => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const answer = document.createElement('div');
      answer.className = 'ss-answer';
      heading.before(details);
      let next = heading.nextSibling;
      while (next && next.nodeName !== 'H2' && next.nodeName !== 'H3') {
        const following = next.nextSibling;
        answer.append(next);
        next = following;
      }
      summary.append(heading);
      details.append(summary, answer);
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceSortedSupport());
else enhanceSortedSupport();
document.addEventListener('shopify:section:load', event => enhanceSortedSupport(event.target));
  } catch(e) { console.error(e); }
})();

})();
